<template>
  <modal :show.sync="showModal" @close="$emit('modalCerrado')">
    <h6 slot="header" class="modal-title">Crear campo de filtro</h6>
    <form class="needs-validation" id="formCreateSearchableAtribute"
        @submit.prevent="sendForm">
      <div class="form-row">
        <div class="col-md-12">
          <base-input label="Nombre identificatorio del campo"
                      name="nombre identificatorio"
                      placeholder="Ingrese un nombre"
                      :error="getError('nombre identificatorio')"
                      v-validate="'required'"
                      v-model="model.name">
          </base-input>
        </div>
        
      </div>
      <div class="form-row">
        <div class="col-md-12">
          <base-input label="Nombre público del campo"
                      name="nombre publico"
                      placeholder="Ingrese un nombre"
                      :error="getError('nombre publico')"
                      v-validate="'required'"
                      v-model="model.name_public">
          </base-input>
        </div>
        
      </div>
      <div class="form-row">
          <div class="col-md-6">
                <base-input label="Tipo de campo">
                    <el-select @change="cambiaTipoCampo"  v-model="model.att_type" filterable
                                placeholder="Seleccione tipo de campo">
                        <el-option v-for="option in selectTiposCampos"
                                    :key="option.label"
                                    :label="option.label"
                                    :value="option.value">
                        </el-option>
                    </el-select>
                </base-input>
          </div>
          <div class="col-md-6">
                <base-input label="Tipo de dato">
                    <el-select  v-model="model.data_type_input" filterable
                                placeholder="Seleccione tipo de campo">
                        <el-option v-for="option in selectTiposDatos"
                                    :key="option.label"
                                    :label="option.label"
                                    :value="option.value">
                        </el-option>
                    </el-select>
                </base-input>
          </div>
      </div>
      <div class="form-row" v-if="model.att_type == 'ENUM'">
          <div class="col-md-12">
                <base-input label="Ingrese opciones disponibles para este campo:">
                    <tags-input  v-model="model.choices" placeholder="Agregar una opcion..." class=""></tags-input>
                </base-input>
          </div>
      </div>
      <card v-if="model.att_type == 'ENUM'">
          <h5 slot="header" class="h4 card-title mb-0">Simulación del campo:</h5>
          <div class="row">
            
            <base-input :label="'Ingrese '+model.name_public+':'">
                <el-select  v-model="ejemploOpciones" filterable
                            :placeholder="'Seleccione '+model.name_public+':'">
                    <el-option v-for="option in model.choices"
                                :key="option.label"
                                :label="option.label"
                                :value="option.value">
                    </el-option>
                </el-select>
            </base-input>
            
          </div>
      </card>
      <card v-if="model.att_type == 'RANGE' || model.att_type == 'VARIABLE'" >
          <h5 slot="header" class="h4 card-title mb-0">Simulación del campo:</h5>
          <div class="container">
          <div class="row">
            <base-input :label="'Ingrese '+model.name_public+':'"
                      :placeholder="'Ingrese '+model.name_public"
                      >
            </base-input>
          </div>
          </div>
      </card>
    </form>

    <template slot="footer">
      <base-button type="primary" nativeType="submit" form="formCreateSearchableAtribute">Guardar Cambios</base-button>
      <base-button type="link" ref="botonCancelar" class="ml-auto" @click="emitirCerrarme">Cancelar</base-button>
    </template>

  </modal>
</template>
<script>
  import BaseTable from '@/components/BaseTable';
  import TagsInput from '@/components/Inputs/TagsInput';
  import { Select, Option } from 'element-ui';
  export default {
    components: {
        BaseTable,
        [Select.name]: Select,
        [Option.name]: Option,
        TagsInput
    },
    data() {
      return {
        from: 'create',
        validated: false,
        model: {
          name: '',
          att_type: '',
          choices: [],
          name_public: '',
          data_type_input: ''
        },
        ejemploOpciones: '',
        showModal: false,
        selectTiposCampos: [
          { label: 'Campo filtro de Opciones', value: 'ENUM' },
          { label: 'Campo filtro rango de valores numéricos', value: 'RANGE' },
          { label: 'Campo de datos cálculo Pricing', value: 'VARIABLE' } 
        ],
        selectTiposDatos: [
          { label: 'Numérico Entero', value: 'int' },
          { label: 'Numérico con Decimales', value: 'float' },
          { label: 'Alfanumérico', value: 'string' } 
        ],
        features: [
            /*
          {
            campo: 'Email Forwarding',
            tipo_campo: '<i class="fas fa-check text-success"></i>',
            tipo_dato: '<i class="fas fa-check text-success"></i>'
          },
          */
        ]
      }
    },
    methods: {
      emitirCerrarme(){
        console.log('me voy a cerrar con el from: ', this.from);
        this.$emit('cerrarModalHijo', this.from);
      },
      cambiaTipoCampo()
      {
        if( this.model.att_type == 'RANGE' || this.model.att_type == 'VARIABLE' ){
          this.selectTiposDatos = [
            { label: 'Numérico Entero', value: 'int' },
            { label: 'Numérico con Decimales', value: 'float' }
          ];
          this.model.data_type_input = 'int';
        }
        if( this.model.att_type == 'ENUM' ){
          this.selectTiposDatos = [
            { label: 'Numérico Entero', value: 'int' },
            { label: 'Numérico con Decimales', value: 'float' },
            { label: 'Alfanumérico', value: 'string' } 
          ];
          this.model.data_type_input = 'string';
        }
      },
      async firstFormSubmit() {
        try {
          return await this.$validator.validateAll();
        } catch {
          console.log('Oh, tengo ke caputar algo');
          return false;
        }
        finally {
          
          this.validated = true;
        }
      },
      getError(name){
        return this.errors.first(name)
      },
      isValid(name) {
        return this.validated && !this.errors.has(name);
      },
      sendForm(){
        var vm = this;
        if( this.model.att_type == 'ENUM' && this.model.choices.length < 1 ){
          this.$notify({
                      message: 'Debes ingresar al menos una opción',
                      timeout: 5000,
                      icon: 'ni ni-bell-55',
                      type: 'default'
                  });
                  return;
        }
        this.firstFormSubmit().then( response => {
          console.log('retorno promesa de validacion', response);
          if( response ){
            
            vm.axios({
                method: 'POST',
                url: 'api/store_create_searchableattribute',
                data: {   
                        nombre_identificatorio: vm.model.name,
                        nombre_publico: vm.model.name_public,
                        tipo_campo: vm.model.att_type,
                        tipo_dato: vm.model.data_type_input,
                        opciones: vm.model.choices.map( e => e.label)
                      }
            }).then( response => {
              vm.$notify({
                      message: 'Campo de búsqueda creado exitosamente!.',
                      timeout: 5000,
                      icon: 'ni ni-bell-55',
                      type: 'success'
                  });
              // Cerrar el Modal
              //vm.showModal = false;
              this.$refs.botonCancelar.$el.click();
              // Emitir evento para que actualize la tabla de usuarios
              vm.$emit('successSending', vm.from);
            }).catch( error => {
                
                if( error.response.status == 422){
                  Object.entries(error.response.data.errors).forEach( elem => {
                    vm.$notify({
                      message: elem[1][0],
                      timeout: 5000,
                      icon: 'ni ni-bell-55',
                      type: 'danger'
                    });
                  });
                }else{
                  console.log(error);
                  vm.$notify({
                        message: 'Hubo un error, no se pudo almacenar el campo de búsqueda',
                        timeout: 5000,
                        icon: 'ni ni-bell-55',
                        type: 'default'
                    });
                }
            });
          }
        }).catch( reason => {
          console.log(reason);
        });
        
      },
    },
    created()
    {
      this.$parent.$on('showModalCreateSearchableAtribute2', (from) => { console.log('Recibí: ',from); this.showModal = true; this.from = from; } )
    },
    
  }
</script>
<style>
</style>
